module.exports = __webpack_public_path__ + "4b0e2ba2edadcec7071cb4862c4ff496.svg";